import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { AngularFirestore } from 'angularfire2/firestore';
import firebase from 'firebase/app'
import { createPipe } from '@angular/compiler/src/core';

@Injectable()
export class EventsProvider {
  collection: any;
  constructor(
    private afs: AngularFirestore
  ) {
  }

  async createEvent(event){
    if(!this.collection)
      this.collection = await this.afs.collection('events');
    event.datetime = new Date();
    // event.id = await this.afs.createId();
    return await this.collection.add(event);
  }


  async getEventsByCategorie(categorie_id){
    return new Promise<any>((resolve, reject) => {
      let result = [];
      let today = Date.now();
      // console.log("getEventsByCategorie",categorie_id);
      this.afs.collection('events', ref => 
      ref.where('category', '==', categorie_id).where("status", "==", 1).where("time_finish", ">", today)
      .orderBy('time_finish')
      )
      .snapshotChanges()
      .pipe(take(1))
      .subscribe(async events => {
        console.log("events loaded",events);
        if(events.length == 0)
          resolve([]);
        for (let item of events) {
          // console.log("item", item);
          let event = item["payload"].doc.data();
          event["id"] = item["payload"].doc.id;
          result.push(event);
          if (result.length == events.length){
            // console.log("getUserChat result", result);
            resolve(result);
          }
        }
      });
    });
  }
  async getEventById(id){
    return new Promise<any>((resolve, reject) => {
      // console.log("getEventsById",id);
      this.afs.doc('events/' + id)
      .valueChanges()
      .pipe(take(1))
      .subscribe(data => {
        data["id"] = id;
        console.log("data",data);
        resolve(data);
      });
    });
  }


  async deleteEvent(event_id){
    // console.log("addUserToEvent event_id ",event_id);
    // console.log("addUserToEvent user_id ",user_id);
   await this.afs.collection('events').doc(event_id).update({
      status: 0
    });
  }
  async addUserToEvent(event_id,user_id){
    // console.log("addUserToEvent event_id ",event_id);
    // console.log("addUserToEvent user_id ",user_id);
    await this.afs.collection('events').doc(event_id).update({
      users: firebase.firestore.FieldValue.arrayUnion(user_id)
    });
  }
  async removeUserToEvent(event_id,user_id){
    // console.log("addUserToEvent event_id ",event_id);
    // console.log("addUserToEvent user_id ",user_id);
    await this.afs.collection('events').doc(event_id).update({
      users: firebase.firestore.FieldValue.arrayRemove(user_id)
    });
  }

  async updateEvent(event_id,event){
    if(!this.collection)
      this.collection = await this.afs.collection('events');
    
    await this.collection.doc(event_id).set(event);
  }

  async getEvents(){
    // console.log("getEvents");
    return new Promise<any>((resolve, reject) => {
      let result = [];
      let today = Date.now();
    this.afs
      .collection("events", ref => {
        return ref.where("status", "==", 1).where("time_finish", ">", today)
        .orderBy('time_finish')
      }
      )
      .snapshotChanges()
      .pipe(take(1))
      .subscribe(async events => {
        console.log("events loaded",events);
        if(events.length == 0)
          resolve([]);
        for (let item of events) {
          // console.log("item", item);
          let event = item["payload"].doc.data();
          event["id"] = item["payload"].doc.id;
          result.push(event);
          if (result.length == events.length){
            // console.log("getUserChat result", result);
            resolve(result);
          }
        }
      });
    });
  }
  async getEventsByPosition(filter,position){
    console.log("getEventsByPosition", filter);
    console.log("getEventsByPosition position", position);
    console.log("getEventsByPosition address."+filter+ "==" + position[filter]);
    return new Promise<any>((resolve, reject) => {
      let result = [];
      let today = Date.now();
    this.afs
      .collection("events", ref => {
        return ref.where("status", "==", 1).where("time_finish", ">", today).where("address."+filter, "==", position[filter])
        .orderBy('time_finish')
      }
      )
      .snapshotChanges()
      .pipe(take(1))
      .subscribe(async events => {
        console.log("events loaded",events);
        if(events.length == 0)
          resolve([]);
        for (let item of events) {
          // console.log("item", item);
          let event = item["payload"].doc.data();
          event["id"] = item["payload"].doc.id;
          result.push(event);
          if (result.length == events.length){
            // console.log("getUserChat result", result);
            resolve(result);
          }
        }
      });
    });
  }

  // getEventList(): firebase.firestore.CollectionReference {
  //   return this.eventListRef;
  // }

  // getEventDetail(eventId: string): firebase.firestore.DocumentReference {
  //   return this.eventListRef.doc(eventId);
  // }

  // uploadEventPicture(eventKey, picture, type?): Promise<any> {
  //   if (type === 'base64') {
  //     return this.eventPictureRef.child(eventKey).child('event-picture.png')
  //         .putString(picture, 'base64', {contentType: 'image/png'});
  //   } else {
  //     return this.eventPictureRef.child(eventKey).child('event-picture.png').put(picture);
  //   }
  // }

  // addGuest(
  //   guestName: string,
  //   eventId: string,
  //   eventPrice: number,
  //   guestPicture: string = null
  // ): Promise<void> {
  //   return this.eventListRef
  //     .doc(eventId)
  //     .collection('guestList')
  //     .add({ guestName })
  //     .then(newGuest => {
  //       return firebase
  //         .firestore()
  //         .runTransaction(transaction => {
  //           return transaction.get(this.eventListRef.doc(eventId)).then(eventDoc => {
  //             const newRevenue = eventDoc.data().revenue + eventPrice;
  //             transaction.update(this.eventListRef.doc(eventId), { revenue: newRevenue });
  //           });
  //         })
  //         .then(() => {
  //           if (guestPicture != null) {
  //             const storageRef = firebase
  //               .storage()
  //               .ref(`/guestProfile/${newGuest.id}/profilePicture.png`);

  //             return storageRef
  //               .putString(guestPicture, 'base64', { contentType: 'image/png' })
  //               .then(() => {
  //                 return storageRef.getDownloadURL().then(downloadURL => {
  //                   return this.eventListRef
  //                     .doc(eventId)
  //                     .collection('guestList')
  //                     .doc(newGuest.id)
  //                     .update({ profilePicture: downloadURL });
  //                 });
  //               });
  //           }
  //         });
  //     });
  // }


  // getObject(document) {
  //   return this.afs.doc(document);
  // }

  // getList(document) {
  //   return this.afs.collection(document);
  // }

  // addItem(document, item) {
  //   return this.afs.collection(document).add(item);
  // }

  // removeItem(document, key) {
  //   return this.afs.collection(document).doc(key).delete();
  // }

  // updateItem(document, data) {
  //   return this.afs.doc(document).update(data);
  // }

  // query(document, options) {
  //   return this.afs.collection(document, options)
  // }
}


// WEBPACK FOOTER //
// ./src/providers/events/events.provider.ts